import { c as _c } from "react/compiler-runtime";
import { INotificationIdentitySubscribed } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationHeader from "../subcomponents/NotificationHeader";
export default function NotificationIdentitySubscribed(t0) {
  const $ = _c(12);
  const {
    notification
  } = t0;
  const t1 = notification.related_identity;
  let t2;
  if ($[0] !== notification.related_identity) {
    t2 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[0] = notification.related_identity;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">started following you</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== notification.created_at) {
    t5 = getTimeAgoShort(notification.created_at);
    $[4] = notification.created_at;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t4}{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== notification.related_identity || $[9] !== t2 || $[10] !== t6) {
    t7 = <div className="tw-w-full"><NotificationHeader author={t1} actions={t2}>{t3}{t6}</NotificationHeader></div>;
    $[8] = notification.related_identity;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}